<template>
  <div v-if="loading" class="custom-global-skeleton tw-w-full tw-h-full"></div>
  <div
    v-else
    class="tw-border tw-border-solid tw-rounded-md tw-border-[#EFF0F1] tw-bg-[#FCFCFC] tw-text-[#211F58] tw-h-[185px]"
  >
    <div
      id="scan-issue-mini-dash-card-title"
      class="tw-h-[56px] tw-flex tw-items-center tw-justify-between tw-text-[16px] tw-p-[20px] tw-color-[211F58] tw-font-[600] border-bottom-issue"
    >
      <div>
        {{
          getComponentUiText("app-scanning-page-issue-mini-dash-card-title-1")
        }}
      </div>
    </div>
    <div
      class="tw-p-[20px] tw-flex tw-items-center tw-gap-[3px] tw-overflow-auto"
    >
      <div class="tw-flex-row tw-items-center tw-gap-x-[3px] tw-flex-1">
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px] background-item"
        >
          {{
            getComponentUiText("app-scanning-page-issue-mini-dash-card-total-1")
          }}
        </div>
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px] background-item"
        >
          {{ scanIssuesCount.total }}
        </div>
      </div>
      <div class="tw-grid tw-items-center tw-gap-y-[3px] tw-flex-1">
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px] background-item"
        >
          {{
            getComponentUiText(
              "app-scanning-page-issue-mini-dash-card-critical-1",
            )
          }}
        </div>
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px] background-critical"
        >
          {{ scanIssuesCount.critical }}
        </div>
      </div>
      <div class="tw-grid tw-items-center tw-gap-y-[3px] tw-flex-1">
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px] background-item"
        >
          {{
            getComponentUiText("app-scanning-page-issue-mini-dash-card-high-1")
          }}
        </div>
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px] background-high"
        >
          {{ scanIssuesCount.high }}
        </div>
      </div>
      <div class="tw-grid tw-items-center tw-gap-y-[3px] tw-flex-1">
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px] background-item"
        >
          {{
            getComponentUiText("app-scanning-page-issue-mini-dash-card-med-1")
          }}
        </div>
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px] background-med"
        >
          {{ scanIssuesCount.med }}
        </div>
      </div>
      <div class="tw-grid tw-items-center tw-gap-y-[3px] tw-flex-1">
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[10px] tw-font-[600] tw-rounded-t-[4px] background-item"
        >
          {{
            getComponentUiText("app-scanning-page-issue-mini-dash-card-low-1")
          }}
        </div>
        <div
          class="tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-px-[20px] tw-py-[10px] tw-text-[13px] tw-font-[600] tw-rounded-b-[4px] background-low"
        >
          {{ scanIssuesCount.low }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getComponentUiText } from "@/utils/utilities";
import { reactive, computed } from "vue";
import store from "@/store";

const data = reactive({
  critical: 2,
  high: 3,
  med: 2,
  low: 3,
});

const props = defineProps({
  loading: {
    type: Boolean,
    default: true,
  },
});

const scanIssuesCount = computed(
  () => store.getters["Scanning/GET_SCANS_ISSUES_COUNTS"],
);
</script>

<style scoped>
.border-bottom-issue {
  border-bottom: 1px solid #eff0f1;
}
.background-item {
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
}
.background-critical {
  color: #f7553c;
  background: var(--UI-red-orange-soft, #fee5e2);
}
.background-high {
  color: #fe9a05;
  background: var(
    --placeholder-orange-soft,
    linear-gradient(
      0deg,
      rgba(254, 154, 5, 0.15) 0%,
      rgba(254, 154, 5, 0.15) 100%
    ),
    #fff
  );
}
.background-med {
  color: #904bd6;
  background: rgba(144, 75, 214, 0.1);
}
.background-low {
  color: #01893d;
  background: var(--UI-green-soft, #d9ede2);
}
</style>
